import React from "react";

const Folder = () => {
	return (
		<svg xmlns="http://www.w3.org/2000/svg" width="13.174" height="12.029" viewBox="0 0 13.174 12.029">
			<path
				id="icons8-folder"
				d="M2.859,4A.864.864,0,0,0,2,4.859V15.17a.864.864,0,0,0,.859.859H14.315a.864.864,0,0,0,.859-.859V6a.864.864,0,0,0-.859-.859H6.582c.025,0-.009,0-.079-.081a3.249,3.249,0,0,1-.246-.358,3.221,3.221,0,0,0-.3-.431A.693.693,0,0,0,5.437,4Zm0,.573H5.437c-.017,0,.018,0,.088.082a3.053,3.053,0,0,1,.247.356,3.382,3.382,0,0,0,.3.43.679.679,0,0,0,.512.277h7.733A.283.283,0,0,1,14.6,6v.626a.841.841,0,0,0-.286-.054H2.859a.841.841,0,0,0-.286.054V4.859A.282.282,0,0,1,2.859,4.573Zm0,2.578H14.315a.282.282,0,0,1,.286.286V15.17a.283.283,0,0,1-.286.286H2.859a.282.282,0,0,1-.286-.286V7.437A.282.282,0,0,1,2.859,7.15Z"
				transform="translate(-2 -4)"
				fill="#fff"
			/>
		</svg>
	);
};

export default Folder;
